import { Molecule } from 'AppReact';
import moment from 'moment';
import styled from 'styled-components';
import { AwardSvg, PercentageSvg } from 'components/icons';
import { getInitials } from 'utils/getInitials';
import { Icon, Image, Initials } from './atoms';
import { PercentageWrapper, TopWrapper } from './wrappers';

const template = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width:  100px;
  height: 100px;
  border-radius: 50%;
  border: ${p => p.size === 'big' ? '8px' : p.size === 'small' ? '2px' : '5px'} solid transparent;
  background-size: 100% 100%, 80% 80%, 50% 50%, 50% 50%, 50% 50%;
  background-repeat: no-repeat;
  background-image: linear-gradient(white, white), 
                    linear-gradient(#1DBD6B 36%, #1DBD6B 30%),
                    linear-gradient(#867DEA 36%, #867DEA 30%),
                    linear-gradient(#FFD84D 36%, #FFD84D 30%),
                    linear-gradient(#FE8363 36%, #FE8363 30%);
  background-position: center center, left top, right top, left bottom, right bottom;
  background-origin: content-box, border-box, border-box, border-box, border-box;
  background-clip: content-box, border-box, border-box, border-box, border-box;

  @media only screen and (min-width: 768px) {
    width:  123px;
    height: 123px;
  }
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Image,
      name: 'Image',
      displayValue: ({ tech }) => tech.image ?? '',
      displayState: ({ tech }) => ({ hidden: !tech.image })
    },
    {
      component: Initials,
      name: 'Initials',
      displayValue: ({ tech }) => getInitials(tech.name).slice(0, 5),
      displayState: ({ tech }) => ({ hidden: !!tech.image })
    },
    {
      wrapper: TopWrapper,
      name: 'Top',
      atoms: [
        {
          component: Icon,
          name: 'Top',
          displayState: ({ tech }) => ({ hidden: !tech.top }),
          displayValue: ({ tech }) => AwardSvg({ top: tech.top ?? 0 })
        }
      ]
    },
    {
      wrapper: PercentageWrapper,
      name: 'Percentage',
      atoms: [
        {
          component: Icon,
          name: 'Percentage',
          displayState: ({ tech }) => ({ hidden: !tech.stats?.completion_time || tech.stats.completion_time <= 0 }),
          displayValue: ({ tech }) => {
            let displayTime = '';
            if (tech.stats?.completion_time) {
              let duration = moment.duration(tech.stats?.completion_time, "seconds");
              if (duration.seconds() >= 1) {
                displayTime = `${Math.floor(duration.seconds())}s`;
              }
              if (duration.minutes() >= 1) {
                displayTime = `${Math.floor(duration.minutes())}m`;
              }
              if (duration.hours() >= 1) {
                displayTime = `${Math.floor(duration.hours())}h`;
              }
              if (duration.days() >= 1) {
                displayTime = `${Math.floor(duration.days())}d`;
              }
            }

            return PercentageSvg({ averageTime: displayTime });
          }
        }
      ]
    }
  ],
})